<template>
  <CRow>

    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-mobile" />
          <h5 class="d-inline ml-2">Devices</h5>
          <div class="card-header-actions">
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "Devices",
  components: {
    BackendTable,
  },
};
</script>
